import { inject, bindable } from "aurelia";
import { getLogger } from "../../common/logging";

let log = getLogger('user-notice');

export class UserNoticeCustomElement {
    constructor() {
        this.hasActiveNotification = false;
        this.notifications = [
            {visibleStart:new Date(2024, 4, 22, 21, 0, 0, 0), visibleEnd:new Date(2024, 4, 23, 13, 0, 0, 0), message:'Systemunderhåll 23 maj 2024 mellan 09.00 - 12.00<br>Vänligen undvik att fylla i eller skicka in ansökningar under denna period!'},
            {visibleStart:new Date(2025, 5, 19, 21, 0, 0, 0), visibleEnd:new Date(2024, 5, 23, 13, 0, 0, 0), message:'Systemunderhåll 23 maj 2024 mellan 09.00 - 12.00<br>Vänligen undvik att fylla i eller skicka in ansökningar under denna period!'},
        ];

        this.notifications = this.notifications.filter((n)=>{
            var currentdate = new Date(); 
            return currentdate.getTime() >=n.visibleStart.getTime() && currentdate.getTime() <= n.visibleEnd.getTime();
        });
        
        this.hasActiveNotification = this.notifications.length;
        let lastActive = this.notifications[this.notifications.length-1];
        if(lastActive){
            lastActive.last = true;
        }
    }
}
